export const contactPageShowForm = () => {
    const tags = document.querySelectorAll('.contact .tags .tags__item');
    const forms = document.querySelectorAll('.contact .form');

    const activateTag = (currentTag) => {
        tags.forEach((tag, index) => {
            tag.classList.remove('tags__item--active');
    
            if (index == currentTag) {
                tag.classList.add('tags__item--active');
            }
        });

        forms.forEach((form, index) => {
            form.classList.add('form--hide');
    
            if (index == currentTag) {
                form.classList.remove('form--hide');
            }
        });
    };

    tags.forEach((tag, index) => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const formActive = parseInt(urlParams.get('formActive'))

        tag.addEventListener('click', () => activateTag(index));

        if (formActive && formActive > 0) {
            if (index == formActive) {
                tag.click();
            }
        } else {
            if (index == 0) {
                tag.click();
            }
        }
    });
};
